export const text = {
	_title: 'Sign up',
	_email: 'email',
	_password: 'password',
	_passwordConf: 'confirm password',
	_firstName: 'first name',
	_lastName: 'last name',
	_company: 'company',
	_newsletter: 'I want to receive newsletter from aircheckr (once a month)',
	_terms: 'I have read and I accept the <a href="https://legal.nazka.be/docs/en/nazka-aircheckr-SaaS-free-plan_17042018_web.pdf" target="_blank">\'SaaS Agreement Free plan\'</a> and the <a href="https://legal.nazka.be/docs/en/terms-of-use/" target="_blank">Terms of Use</a>',
	_submit: 'Sign up'
}

export const login = {
	_title: 'Already have an account?',
	_body: ' with an existing account'
}

export default text;



// WEBPACK FOOTER //
// ./src/input-text/en/signup_page.js